export { FacetBreadcrumbs } from './FacetBreadcrumbs';
export type { FacetBreadcrumbsProps } from './FacetBreadcrumbs.types';
